enum InputFormatTypes {
  Normal = 'normal',
  Rounded = 'rounded',
}

export default InputFormatTypes
